import { useEffect } from 'react';

export const useOnAnyActivity = (onAnyActivity: () => void) => {
    useEffect(() => {
        window.addEventListener('mousemove', onAnyActivity);
        window.addEventListener('click', onAnyActivity);
        window.addEventListener('scroll', onAnyActivity);
        window.addEventListener('keypress', onAnyActivity);

        return () => {
            window.removeEventListener('mousemove', onAnyActivity);
            window.removeEventListener('click', onAnyActivity);
            window.removeEventListener('scroll', onAnyActivity);
            window.removeEventListener('keypress', onAnyActivity);
        };
    }, [onAnyActivity]);
};
